import Vue from 'vue'
import 'mutationobserver-shim'
import './Utils/fliter'
import App from './App.vue'
import router from './router'
// import router from './router/index_bk'
import store from './store'
import Raphael from 'raphael/raphael'
import './plugins'
import './registerServiceWorker'
import AlgoliaComponents from 'vue-instantsearch'
import i18n from './i18n'
import SocketIO from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
import dotenv from 'dotenv'

dotenv.config({ path: '../.env' })

global.Raphael = Raphael

Vue.use(AlgoliaComponents)

Vue.config.productionTip = false

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: SocketIO(process.env.VUE_APP_WS_HOST, {
      autoConnect: false
      // query will be update on using component
      // query: { auth_token: store.getters['Auth/authUserState'].token }
    }),
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
    }
  })
)

let vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.vm = vm
